// Utility functions for dynamic CSS and JS injection

export const DYNAMIC_IDS = {
  HEADER_CSS: 'dynamic-header-css',
  HEADER_JS: 'dynamic-header-js',
  BODY_OPEN_CSS: 'dynamic-body-open-css',
  BODY_OPEN_JS: 'dynamic-body-open-js',
  BODY_CLOSE_CSS: 'dynamic-body-close-css',
  BODY_CLOSE_JS: 'dynamic-body-close-js',
};

export const checkInjectedContent = () => {
  const injected = {};

  Object.entries(DYNAMIC_IDS).forEach(([key, id]) => {
    const element = document.getElementById(id);
    injected[key] = {
      exists: !!element,
      content: element?.textContent || element?.innerHTML || null,
    };
  });

  return injected;
};

export const removeAllInjectedContent = () => {
  Object.values(DYNAMIC_IDS).forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.remove();
    }
  });
};

export const validateCSS = (cssContent) => {
  if (!cssContent || typeof cssContent !== 'string') {
    return { valid: false, error: 'Invalid CSS content' };
  }

  try {
    let trimmed = cssContent.trim();

    if (trimmed.startsWith('<style')) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(trimmed, 'text/html');
      const styleTag = doc.querySelector('style');
      if (styleTag) trimmed = styleTag.textContent;
    }

    if (trimmed === '') {
      return { valid: false, error: 'Empty CSS content' };
    }

    const hasBraces = trimmed.includes('{') && trimmed.includes('}');
    if (!hasBraces) {
      return { valid: false, error: 'Invalid CSS syntax - missing braces' };
    }

    return { valid: true };
  } catch (error) {
    return { valid: false, error: error.message };
  }
};

export const validateJS = (jsContent) => {
  if (!jsContent || typeof jsContent !== 'string') {
    return { valid: false, error: 'Invalid JS content' };
  }

  try {
    let trimmed = jsContent.trim();

    if (trimmed.includes('<script')) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(trimmed, 'text/html');
      const scriptTags = doc.querySelectorAll('script');

      if (scriptTags.length === 0) {
        return { valid: false, error: 'No <script> tags found' };
      }

      let allValid = true;
      let hasExternal = false;

      for (const scriptTag of scriptTags) {
        if (scriptTag.hasAttribute('src')) {
          hasExternal = true;
          continue;
        }

        const code = scriptTag.textContent;
        if (code.trim() === '') continue;

        try {
          new Function(code);
        } catch (error) {
          allValid = false;
          break;
        }
      }

      if (allValid) {
        return { valid: true, isExternal: hasExternal };
      }

      return { valid: false, error: 'Invalid inline JS in one of the script tags' };
    }

    if (trimmed === '') {
      return { valid: false, error: 'Empty JS content' };
    }

    new Function(trimmed);
    return { valid: true, isExternal: false };
  } catch (error) {
    return { valid: false, error: error.message };
  }
};

export const logInjectionStatus = (data) => {
  if (!data) return {};

  return {
    headerCSS: data.header_custom_css ? validateCSS(data.header_custom_css) : null,
    headerJS: data.header_custom_js ? validateJS(data.header_custom_js) : null,
    bodyOpenCSS: data.body_open_custom_css ? validateCSS(data.body_open_custom_css) : null,
    bodyOpenJS: data.body_open_custom_js ? validateJS(data.body_open_custom_js) : null,
    bodyCloseCSS: data.body_close_custom_css ? validateCSS(data.body_close_custom_css) : null,
    bodyCloseJS: data.body_close_custom_js ? validateJS(data.body_close_custom_js) : null,
  };
};
